import dayjs from "dayjs"
import React from "react"
import { UserRole } from "../../../../../backend/src/types"

export type AppAuthProviderContextLoggedUser = {
    id: number
    email: string
    firstName: string
    surName: string
    preTitle?: string
    postTitle?: string
    birthDate?: dayjs.Dayjs
    roles: {
        companyId?: number | null
        company?: LoggedUserCompany | null
        role: UserRole
        oneTimeLimit?: number | null
        yearlyLimit?: number | null
    }[]
}

export type LoggedUserCompany = { displayName: string }

export type AppAuthProviderContextProps = {
    accessToken: string | undefined
    logout: () => void
    loggedUser?: AppAuthProviderContextLoggedUser
    setTokens: (tokens: {
        accessToken: string
        accessTokenExpiresIn: number
        refreshToken: string
        refreshTokenExpiresIn: number
    }) => void
    hasRole: (role: UserRole | UserRole[], companyId?: number | null) => boolean
    getCompanies: (role: UserRole | UserRole[]) => number[]
    getLimits: (
        role: UserRole,
        companyId?: number
    ) => {
        oneTimeLimit: number | null | undefined
        yearlyLimit: number | null | undefined
    }
    personificateUser: (userId: number) => Promise<void>
}
const AppAuthProviderContext = React.createContext<AppAuthProviderContextProps>({
    accessToken: undefined,
    logout: () => undefined,
    setTokens: () => undefined,
    hasRole: () => false,
    getLimits: () => ({ oneTimeLimit: undefined, yearlyLimit: undefined }),
    getCompanies: () => [],
    personificateUser: async () => undefined,
})
export default AppAuthProviderContext
